import AgAgencyManage from '@/pages/agentManage/agAgencyManage'

export default [
  {
    path: '/agAgencyManage',
    name: 'AgAgencyManage',
    component: AgAgencyManage,
    meta: { name: '代理管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/agentManage/agAgencyManage.js